import React from "react";

import CardContent, { CardContentProps } from "@mui/material/CardContent";

function MapCardContent(props: CardContentProps) {
  return <CardContent {...props} sx={{ p: 1 }} />;
}

export default MapCardContent;
